import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { IST } from '../../lib/dayjsIst';

function isoToDayjs(iso) {
  if (!iso) return null;
  const d = dayjs(iso);
  if (!d.isValid()) return null;
  return d.tz(IST);
}

function dayjsToIstIso(d) {
  if (!d || !d.isValid()) return '';
  return `${d.tz(IST).format('YYYY-MM-DDTHH:mm:ss')}+05:30`;
}

export default function HealthDateTimeField({ label, value, onChange, required }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker
        label={label ? `${label} (IST)` : 'Document date & time (IST)'}
        value={isoToDayjs(value)}
        onChange={(v) => onChange(dayjsToIstIso(v))}
        timezone={IST}
        ampm
        closeOnSelect={false}
        slotProps={{
          textField: {
            required,
            fullWidth: true,
          },
          popper: {
            sx: { zIndex: (theme) => theme.zIndex.modal + 2 },
          },
          dialog: {
            sx: { zIndex: (theme) => theme.zIndex.modal + 2 },
          },
        }}
      />
    </LocalizationProvider>
  );
}
